import { render, staticRenderFns } from "./OrderPrepare.vue?vue&type=template&id=4b529d46&scoped=true&"
import script from "./OrderPrepare.vue?vue&type=script&lang=js&"
export * from "./OrderPrepare.vue?vue&type=script&lang=js&"
import style0 from "./OrderPrepare.vue?vue&type=style&index=0&id=4b529d46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b529d46",
  null
  
)

export default component.exports